import { useState } from 'react'
import {
  useNavigate,
  // useLocation
} from 'react-router'
import { useTranslation } from 'react-i18next'
import Header from '@components/Header/Header'
import TextInput from '@components/TextInput/TextInput'
import AccentAlert from '@components/AccentAlert/AccentAlert'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import { AMBER_500 } from '@styles/colors'
import {
  Container,
  ContentContainer,
  TitleSection,
  Title,
  Description,
  InputSection,
  AlertSection,
  AlertIcon,
  AlertContent,
  AlertTitle,
  AlertList,
  ButtonWrapper
} from './BuyESIMDetails.styles'
import ExclamationMarkIcon from '@components/ExclamationMarkIcon/ExclamationMarkIcon'

const BuyESIMDetails = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  // const location = useLocation()
  // const { plan, phoneNumber } = location.state || {}

  const [email, setEmail] = useState('')
  const [whatsapp, setWhatsapp] = useState('')

  const handleContinue = () => {
    navigate('/payment-confirm', {
      state: {
        email,
        whatsapp,
        serviceType: 'buy-esim'
      }
    })
  }

  const isContinueDisabled = !email || !whatsapp

  return (
    <Container>
      <Header
        title={t('buyESIMDetails.header')}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <ContentContainer>
        <TitleSection>
          <Title>{t('buyESIMDetails.title')}</Title>
          <Description>{t('buyESIMDetails.description')}</Description>
        </TitleSection>

        <InputSection>
          <TextInput
            title={t('buyESIMDetails.emailAddress')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('buyESIMDetails.emailPlaceholder')}
            inputMode="email"
          />
          <TextInput
            title={t('buyESIMDetails.whatsappNumber')}
            value={whatsapp}
            onChange={(e) => setWhatsapp(e.target.value)}
            placeholder={t('buyESIMDetails.whatsappPlaceholder')}
            inputMode="tel"
          />
        </InputSection>

        <AlertSection>
          <AccentAlert>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 4,
                marginBottom: 4
              }}
            >
              <AlertIcon>
                <ExclamationMarkIcon
                  width={16}
                  height={16}
                  outline={"#F2AF01"}
                  exclamationColor={"white"}
                  fill={"#F2AF01"}
                />
              </AlertIcon>
              <AlertTitle>{t('buyESIMDetails.alertTitle')}</AlertTitle>
            </div>
            <AlertContent>
              <AlertList>
                <li>{t('buyESIMDetails.alertItem1')}</li>
                <li>{t('buyESIMDetails.alertItem2')}</li>
                <li>{t('buyESIMDetails.alertItem3')}</li>
              </AlertList>
            </AlertContent>
          </AccentAlert>
        </AlertSection>
      </ContentContainer>

      <ButtonWrapper>
        <PrimaryButton
          onClick={handleContinue}
          disabled={isContinueDisabled}
        >
          {t('buyESIMDetails.continue')}
        </PrimaryButton>
      </ButtonWrapper>
    </Container>
  )
}

export default BuyESIMDetails
